import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getProductBySlug, getOffersByProductId } from '../../utils/api';
import SimpleProductPage from './SimpleProductPage';

const ProductComparisonPage = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [offers, setOffers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setError(null);
    setProduct(null);
    setOffers(null);

    const load = async () => {
      try {
        const productData = await getProductBySlug(slug);
        if (cancelled) return;
        if (!productData) {
          setNotFound(true);
          setLoading(false);
          return;
        }
        setProduct(productData);
        const offersResult = await getOffersByProductId(productData.id);
        if (cancelled) return;
        const safeOffers = Array.isArray(offersResult?.data)
          ? offersResult.data.filter((item) => typeof item?.numeric_price === 'number' && Number.isFinite(item.numeric_price) && item.numeric_price > 0)
          : [];
        setOffers(safeOffers);
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'Something went wrong');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading...
      </div>
    );
  }

  if (notFound) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Product not found
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        {error}
      </div>
    );
  }

  if (!product) {
    return null;
  }

  return (
    <SimpleProductPage
      specificProductId={product.slug}
      productName={product.name}
      productImage={product.image_url}
      csvLookupId={product.name}
      csvExactMatchOnly={true}
      prefetchedOffers={offers}
      msrp={product.msrp}
    />
  );
};

export default ProductComparisonPage;
